// extracted by mini-css-extract-plugin
export default {"IssueTypeToken":"IssueType-module__IssueTypeToken--hdXht","hiddenPlaceholder":"IssueType-module__hiddenPlaceholder--nnfV9"};